import type { IOrder } from '@/types';
import { Flex, Grid, GridItem, Text } from '@chakra-ui/react';

interface IDocumentProps {
  shipment: IOrder | undefined;
}

export const DocumentInfoBox: React.FC<IDocumentProps> = (props): JSX.Element => {
  const { shipment } = props;

  return (
    <Grid
      border="2px"
      borderColor="gray.200"
      gap={10}
      gridTemplateColumns="1fr 1fr"
      gridTemplateRows="1fr 1fr"
      mt={10}
      px={10}
      py={10}
    >
      <GridItem>
        <Flex direction="column">
          <Text fontSize={14}>DESTINATARIO</Text>
          <Text fontWeight="bold">
            {shipment?.customer.firstName} {shipment?.customer.lastName}
          </Text>
          <Text>{shipment?.customer.streetAddress}</Text>
          <Text>
            {shipment?.customer.zipCode} {shipment?.customer.city} {shipment?.customer.province}
          </Text>
        </Flex>
      </GridItem>
      <GridItem>
        <Flex direction="column">
          <Text fontSize={14}>RITIRO</Text>
          <Text fontWeight="bold">{shipment?.auctionHouse.name}</Text>
          <Text>{shipment?.auctionHouse.streetAddress}</Text>
          <Text>
            {shipment?.auctionHouse.zipCode} {shipment?.auctionHouse.city}{' '}
            {shipment?.auctionHouse.province}
          </Text>
        </Flex>
      </GridItem>
      <GridItem>
        <Flex direction="column">
          <Text fontSize={14}>OGGETTO</Text>
          <Text fontWeight="bold">{shipment?.item.name}</Text>
          <Text>
            {shipment?.item.width} x {shipment?.item.height} x {shipment?.item.length} cm
          </Text>
          <Text>{shipment?.item.weight} kg</Text>
        </Flex>
      </GridItem>
      <GridItem>
        <Flex direction="column">
          <Text fontSize={14}>RIFERIMENTI LOTTO</Text>
          <Text fontWeight="bold">Lotto {shipment?.auctionHouse.batchCode}</Text>
          <Text>Asta {shipment?.auctionHouse.auctionCode}</Text>
          <Text>del {shipment?.auctionHouse.auctionDate}</Text>
        </Flex>
      </GridItem>
    </Grid>
  );
};
